"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18.787 3h-8.771c-1.22 0-2.213.992-2.213 2.213v2.49H5.346A2.345 2.345 0 003 10.05v8.605A2.346 2.346 0 005.346 21h8.605a2.346 2.346 0 002.346-2.346v-2.457h2.49c1.22 0 2.213-.993 2.213-2.213V5.213C21 3.993 20.007 3 18.787 3zm-.059 10.926h-8.654V5.27h8.654v8.655z" }), "Drag");
//# sourceMappingURL=Drag.js.map